import React from 'react';
import { DiscordIcon, CnTelegramIcon, TwitterSVG, TelegramIcon } from 'common-helpers/img';
import styled from 'styled-components';
import { SocialType } from 'constant/socialAuth';

const SocialIconWrapper = styled.div<{ size: 'sm' | 'md' | 'lg' | string }>`
    width: ${({ size }) => (size === 'sm' && '24px') || (size === 'md' && '30px') || (size === 'lg' && '48px')};
    height: ${({ size }) => (size === 'sm' && '24px') || (size === 'md' && '30px') || (size === 'lg' && '48px')};
    /* border: 1px solid #585858; */
    /* border-radius: ${({ size }) =>
        (size === 'sm' && '8px') || (size === 'md' && '10px') || (size === 'lg' && '10px')}; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    svg {
        width: ${({ size }) => (size === 'sm' && '12px') || (size === 'md' && '16px') || (size === 'lg' && '24px')};
        height: ${({ size }) => (size === 'sm' && '12px') || (size === 'md' && '16px') || (size === 'lg' && '24px')};
    }
`;

const getIcon = (type: SocialType | null) => {
    switch (type) {
        case SocialType.Twitter:
            return TwitterSVG;
        case SocialType.TelegramCN:
            return CnTelegramIcon;
        case SocialType.Telegram:
            return TelegramIcon;
        case SocialType.Discord:
            return DiscordIcon;
        default:
            return null;
    }
};

interface IconProps {
    type: SocialType | null;
    size?: string;
}

const SocialMediaIcon = ({ type, size = 'lg' }: IconProps) => {
    const Icon = getIcon(type);
    return Icon ? (
        <SocialIconWrapper size={size}>
            <Icon />
        </SocialIconWrapper>
    ) : null;
};

export default SocialMediaIcon;
